export default __webpack_public_path__ + "static/media/logo3.8f9b71f6.png";